import React from 'react';
import PollViewer from '../viewer/poll-viewer.js';
import 'ricos-context';
import 'wix-rich-content-editor-common/libs/EditorEventsContext';
import '../components/rce-helpers-context/index.js';
import 'prop-types';
import '../viewer/poll-component.js';
import 'classnames';
import 'react-flip-move';
import 'react-measure';
import 'ricos-schema';
import '../style-inject.es-e7b07dd7.js';
import '../components/poll-option/index.js';
import '../components/poll-option/PollGridOption.js';
import 'wix-rich-content-common/libs/Tooltip';
import '../dataHooks.js';
import '../RemoveOption-5414440c.js';
import '../assets/icons/RemoveIcon.js';
import '../components/poll-option/PollOptionBase.js';
import '../components/poll-option/types.js';
import '../components/poll-context/types.js';
import '../assets/icons/NonEditableIcon.js';
import '../assets/icons/CheckIcon.js';
import '../components/image-upload/ImageUpload.js';
import 'wix-rich-content-common/libs/imageUtils';
import '../defaults.js';
import '../helpers.js';
import 'ricos-schema/next';
import 'wix-rich-content-editor-common';
import '../components/image-upload/types.js';
import '../assets/icons/LoaderIcon.js';
import '../assets/icons/ReplaceIcon.js';
import '../components/text-field/TextField.js';
import 'lodash';
import '../components/poll-option/PollListOption.js';
import '../components/poll-option/webview/PollListOptionWebview.js';
import '../option-webview-e9bd4b55.js';
import '../components/poll-option/webview/PollGridOptionWebview.js';
import '../components/poll-header/PollHeader.js';
import '../components/poll-context/PollContext.js';
import '../components/voted-users/VotedUsers.js';
import '../components/voted-users/types.js';
import 'react-modal';
import '../VotedUsersModal-bf00b37a.js';
import 'react-infinite-scroller';
import '../components/voted-users/VoterAvatar.js';
import 'wix-rich-content-ui-components';
import '../components/voted-users/FallbackAvatar.js';
import '../assets/icons/AddIcon.js';

const Poll = ({
  settings,
  componentData,
  node,
  updateAttributes,
  selected
}) => {
  const block = { getKey: () => node.attrs.id };
  const helpers = { handleFileUpload: settings.handleFileUpload };
  return /* @__PURE__ */ React.createElement("div", null, /* @__PURE__ */ React.createElement(
    PollViewer,
    {
      componentData,
      settings,
      updateAttributes,
      block,
      selected,
      helpers
    }
  ));
};

export { Poll };
//# sourceMappingURL=component.js.map
